/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Quicktools_TitleInputs */



/**
* | output |
* | --- |
* | "QuickTools Settings" |
*
* @param {Options_Quicktools_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_quicktools_title = /** @type {((inputs?: Options_Quicktools_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Quicktools_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres QuickTools")
	if (locale === "de") return /** @type {LocalizedString} */ ("QuickTools-Einstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni QuickTools")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки быстрых инструментов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración de QuickTools")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("快速工具设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クイックツール設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्विकटूल्स सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações do QuickTools")
	return /** @type {LocalizedString} */ ("QuickTools Settings")
});